import React, { forwardRef } from 'react';
import styles from './styles.module.scss';
import { useContext } from 'react';
import { AdminContext } from '../../context/AdminContext';

const AppInput = forwardRef((props, ref) => {
  const { themeColor } = useContext(AdminContext);

  return (
    <div
      className={`${styles.container}${` `}${props?.className} selectButton`}
      onClick={props?.onClick}
    >
      <div className={`${styles.wrapper}  ${props?.wrapper}`}>
        {props?.prefix && (
          <div className={props?.prefixClass}>{props?.prefix}</div>
        )}
        <input
          onChange={props?.onChange}
          placeholder={props?.placeholder}
          value={props?.value}
          onKeyDown={props?.onKeyDown}
          disabled={props?.disabled}
          ref={ref}
          id={props?.id}
          onClick={props?.onClickInput}
          type={props?.type}
          inputclassname={props?.inputclassname}
          onFocus={props?.onFocus ? props?.onFocus : console.log('h')}
          onBlur={props?.onBlur ? props?.onBlur : console.log('b')}
          autoFocus={props?.autoFocus ? true : false}
        />

        {props?.affix && (
          <div
            className={`${styles.affix} ${
              themeColor == 'black' && 'makeWhite'
            }`}
          >
            {props?.affix}
          </div>
        )}
        {props?.affix3 && (
          <div
            className={`${styles.affix} ${
              themeColor == 'black' && 'makeWhite'
            }`}
          >
            {props?.affix3}
          </div>
        )}
        {props?.affix2 && (
          <div
            className={`${styles.affix} ${
              themeColor == 'black' && 'makeWhite'
            }`}
          >
            {props?.affix2}
          </div>
        )}
      </div>
    </div>
  );
});
AppInput.displayName = 'AppInput';
export default AppInput;
